import type { DashboardRole } from './session';

export const DASHBOARD_USER_STATUSES = ['Invited', 'Active', 'Deactivated'] as const;
export type DashboardUserStatus = (typeof DASHBOARD_USER_STATUSES)[number];

export const DASHBOARD_ORGANISATION_TYPES = ['GroundHandler', 'FulfillmentCenter'] as const;
export type DashboardOrganisationType = (typeof DASHBOARD_ORGANISATION_TYPES)[number];

/** One row of `GET /api/v1/users`, and the shape `POST /api/v1/users/invite` returns. */
export interface DashboardUserRow {
  id: string;
  email: string;
  displayName: string;
  userType: DashboardRole;
  status: DashboardUserStatus;
  organisationType: DashboardOrganisationType | null;
  organisationKey: string | null;
  dateAdded: string;
}
